import React from 'react';
import PropTypes from 'prop-types';

class Duration extends React.Component {
    static propTypes = {
        duration: PropTypes.number.isRequired,
        long: PropTypes.bool,
        showBrackets: PropTypes.bool,
    };

    render() {
        const {duration, long, showBrackets} = this.props;

        return (
            <span>
                {showBrackets && '('}

                {!long && (
                    Math.floor(duration / 60) + ':' + ('' + duration % 60).padStart(2, '0')
                )}
                {long && (
                    Math.floor(duration / 3600).toString(10) + ':' + Math.floor((duration % 3600) / 60).toString(10).padStart(2, '0') + ':' + ('' + duration % 60).padStart(2, '0')
                )}

                {showBrackets && ')'}
            </span>
        )
    }
}

export default Duration;


// WEBPACK FOOTER //
// ./src/components/Duration.jsx